<div
  class="k-card cursor-pointer {{ item().status }}"
  [ngClass]="{ 'is-overdue': item().isOverDue, 'is-dense': isSimpleMode() }"
  (click)="openItemEditModal(item().id, item().itemKey, item().boardKey)"
>
  <div class="k-card__main">
    <mat-icon class="k-card__status-icon">{{ statusIcon() }}</mat-icon>
    <span class="k-card__title" [matTooltip]="item().title">{{ item().title }}</span>
    <mat-icon
      class="k-card__overdue-icon"
      *ngIf="item().isOverDue"
      [matTooltip]="'page.items.label.overdue' | translate"
      >error_outline</mat-icon
    >
  </div>

  <div class="k-card__meta">
    <app-inline-user-chip
      class="k-card__assignee"
      [name]="item().assigneeName!"
      [boardId]="item().boardId"
      [itemId]="item().id"
      (triggerRefresh)="triggerRefresh()"
      (click)="$event.stopPropagation()"
      ><app-text-avatar [text]="item().assigneeName!"></app-text-avatar
    ></app-inline-user-chip>

    <span class="k-card__key">{{ item().itemKey }}</span>

    <button
      class="k-card__action"
      mat-icon-button
      (click)="onStatusChange($event)"
      [matTooltip]="'filterCard.status' | translate"
    >
      <mat-icon>sync</mat-icon>
    </button>
  </div>
</div>
